import { ReactFlowProvider } from '@xyflow/react';
import { CanvasReferencesContextProvider } from './internal-context/CanvasReferencesContext';
import { createContext } from 'react';
import { SweepCanvasStateProvider } from './internal-context/CanvasStateContext';

export const SweepCanvasProvidersInitializedCtx = createContext<boolean>(false);

export const SweepCanvasProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <SweepCanvasProvidersInitializedCtx.Provider value={true}>
      <CanvasReferencesContextProvider>
        <SweepCanvasStateProvider>
          <ReactFlowProvider>{children}</ReactFlowProvider>
        </SweepCanvasStateProvider>
      </CanvasReferencesContextProvider>
    </SweepCanvasProvidersInitializedCtx.Provider>
  );
};
